import type { OrchestrationThreadSearchMatch } from "@cmmd-forge/contracts";

/** Mark each case-insensitive query occurrence while keeping the server's original excerpt text. */
function HighlightedSearchText(props: { readonly text: string; readonly query: string }) {
  const query = props.query.trim();
  if (query.length === 0) return props.text;
  const matcher = new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "gi");
  const parts: { readonly text: string; readonly highlighted: boolean; readonly start: number }[] =
    [];
  let cursor = 0;
  for (const match of props.text.matchAll(matcher)) {
    const index = match.index;
    if (index > cursor) {
      parts.push({ text: props.text.slice(cursor, index), highlighted: false, start: cursor });
    }
    parts.push({
      text: match[0],
      highlighted: true,
      start: index,
    });
    cursor = index + match[0].length;
  }
  if (cursor < props.text.length) {
    parts.push({ text: props.text.slice(cursor), highlighted: false, start: cursor });
  }
  return parts.map((part) =>
    part.highlighted ? (
      <mark className="bg-transparent font-semibold text-foreground" key={part.start}>
        {part.text}
      </mark>
    ) : (
      part.text
    ),
  );
}

/** Upstream's two-line search row excerpt with Forge's semantic status colors. */
export function SidebarV2SearchExcerpt(props: {
  readonly match: OrchestrationThreadSearchMatch;
  readonly query: string;
}) {
  const fromUser = props.match.source === "user";
  return (
    <span className="truncate text-xs text-muted-foreground/85">
      <span className={fromUser ? "text-info-foreground" : "text-success-foreground"}>
        {fromUser ? "You:" : "Agent:"}
      </span>{" "}
      <HighlightedSearchText text={props.match.snippet} query={props.query} />
    </span>
  );
}
